import * as React from "react";
import type { SVGProps } from "react";
const SvgWaterWaves = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.98 11c-.5-.01-.97-.13-1.42-.35v-.01c-.49-.25-.7-.85-.45-1.34s.85-.69 1.34-.45c.18.1.38.15.58.15.45.05.89-.21 1.16-.58.65-.91 1.73-1.43 2.83-1.42 1.09 0 2.14.51 2.79 1.42.27.37.71.56 1.17.58.48-.01.94-.2 1.21-.58.65-.91 1.72-1.43 2.83-1.42 1.09 0 2.14.51 2.79 1.43.27.37.7.56 1.17.58.2-.01.4-.06.58-.15a.99.99 0 0 1 1.34.45c.25.49.05 1.09-.45 1.34-.45.22-.93.34-1.42.35-1.16.01-2.19-.51-2.84-1.42-.27-.37-.72-.6-1.17-.58-.51-.02-.94.2-1.21.58-.64.89-1.67 1.42-2.76 1.42h-.14c-1.05 0-2.08-.53-2.72-1.42-.27-.37-.71-.6-1.17-.58-.5-.02-.94.2-1.21.58C6.16 10.49 5.1 11 3.98 11m16 4c.2-.01.4-.06.58-.15a.99.99 0 0 1 1.34.45c.25.49.05 1.09-.45 1.34-.45.22-.93.34-1.42.35-1.16-.02-2.19-.51-2.84-1.42-.27-.37-.72-.58-1.17-.58-.51-.01-.94.2-1.21.58-.64.89-1.67 1.42-2.76 1.42h-.14c-1.05 0-2.08-.53-2.72-1.42-.27-.37-.71-.58-1.17-.58-.5-.01-.94.2-1.21.58a3.38 3.38 0 0 1-4.25 1.07c-.49-.25-.7-.85-.45-1.34s.85-.69 1.34-.45c.18.1.38.15.58.15.45.02.89-.2 1.16-.58.65-.91 1.73-1.41 2.83-1.42 1.08.02 2.14.51 2.79 1.42.27.37.71.58 1.17.58.48-.01.94-.2 1.21-.58.65-.91 1.72-1.41 2.83-1.42 1.09.02 2.14.51 2.79 1.42.27.37.7.58 1.17.58"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgWaterWaves;
